// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__BlB6C","legacyBtn":"MutateMid_legacyBtn__nZgrN"};